import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Grid2 as Grid,
  IconButton,
  Tooltip,
  useTheme,
  Box,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import InfoIcon from '@mui/icons-material/Info'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'
import EmailIcon from '@mui/icons-material/Email'
import CallIcon from '@mui/icons-material/Call'
import MyLocationIcon from '@mui/icons-material/MyLocation'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

const styles = (theme: any) => ({
  card: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  fieldLabel: {
    fontSize: theme.typography.pxToRem(13),
    color: Colors.TEXT_COLOR_TERTIARY,
    fontWeight: 400,
  },
  fieldValue: {
    fontWeight: 400,
    color: Colors.TEXT_COLOR_SECONDARY,
    fontSize: theme.typography.pxToRem(14),
  },
  infoIcon: {
    fontSize: theme.typography.pxToRem(16),
    marginLeft: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    verticalAlign: 'middle',
  },
  editButton: {
    color: Colors.TEXT_COLOR_SECONDARY,
    padding: 5,
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
  },
  iconBox: {
    padding: 5,
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
    fontSize: 30,
    display: 'flex',
    justifyContent: 'center',
  },
})

interface BasicDetailsCardProps {
  section?: React.ReactNode
}

const BasicDetailsCard = ({ section }: BasicDetailsCardProps) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <div className={classes?.header}>
        <Typography variant='subtitle1' fontWeight='bold'>
          Basic Details
        </Typography>
        <IconButton
          size='small'
          color='primary'
          className={classes?.editButton}
        >
          <EditIcon />
        </IconButton>
      </div>
      <CardContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <Box className={classes?.iconBox}>
                <EmailIcon fontSize='small' />
              </Box>
              <Box>
                <Typography className={classes?.fieldLabel}>Email</Typography>
                <Typography className={classes?.fieldValue}>
                  Joel Mihavel@gmail.com
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <Box className={classes?.iconBox}>
                <CallIcon fontSize='small' />
              </Box>
              <Box>
                <Typography className={classes?.fieldLabel}>Contact</Typography>
                <Typography className={classes?.fieldValue}>
                  7999000123
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <Box className={classes?.iconBox}>
                <AccessTimeIcon fontSize='small' />
              </Box>
              <Box>
                <Typography className={classes?.fieldLabel}>
                  Last Contacted
                </Typography>
                <Typography className={classes?.fieldValue}>
                  06/07/2024 at 7:00 pm
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <Box className={classes?.iconBox}>
                <MyLocationIcon fontSize='small' />
              </Box>
              <Box>
                <Typography className={classes?.fieldLabel}>Source</Typography>
                <Typography className={classes?.fieldValue}>
                  KIMS Hospital
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <Box className={classes?.iconBox}>
                <PeopleAltIcon fontSize='small' />
              </Box>
              <Box>
                <Typography className={classes?.fieldLabel}>
                  Family Size
                </Typography>
                <Typography className={classes?.fieldValue}>
                  4 People
                  <Tooltip title='Number of members in the family'>
                    <InfoIcon className={classes?.infoIcon} />
                  </Tooltip>
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Typography className={classes?.fieldLabel}>Policy ID</Typography>
            <Typography className={classes?.fieldValue}>
              17238731973137091819
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Typography className={classes?.fieldLabel}>Policy Name</Typography>
            <Typography className={classes?.fieldValue}>
              Ayuvu Bharat
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, lg: 4, md: 4, xl: 4 }}>
            <Typography className={classes?.fieldLabel}>
              Start - End Date
            </Typography>
            <Typography className={classes?.fieldValue}>
              12/12/2024 - 24/10/2024
            </Typography>
          </Grid>
        </Grid>
        {section}
      </CardContent>
    </Card>
  )
}

export default BasicDetailsCard
